import axios, { AxiosRequestConfig } from 'axios';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import React, { useState, useRef } from 'react';
import { useAuth } from '../../context/AuthProvider';

export const CommodityCreator = () => {
    const [label, setLabel] = useState('')
    const [code, setCode] = useState('')
    const [showDialog, setShowDialog] = useState(false)
    const toast = useRef(null)

    const { session } = useAuth();

    const handleSubmitClick = async () => {
        try {
            const config: AxiosRequestConfig = {
                headers: {
                    "Authorization": `Bearer ${session.access_token}`,
                }
            }
            await axios.post('/api/commodities', { label, code }, config)
            successToast()
            setLabel('')
            setCode('')
        }
        catch (error) {
            console.error(error)
            let errorMessage;

            if (axios.isAxiosError(error)) {
                const message = error.response?.data?.message || ''

                if (message.includes('commodities_code_key')) {
                    errorMessage = 'Code must be unique.'
                } else if (message.includes('commodities_label_key')) {
                    errorMessage = 'Label must be unique.'
                }
                failToast(errorMessage)
            } else {
                failToast()
            }
        }
    }

    const successToast = () => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Added commodity successfully!' });
    };

    const failToast = (err_text = null) => {
        toast.current.show({ severity: 'error', summary: 'Failed', detail: err_text || 'Failed to add commodity.' });
    };

    const isformValid = () => {
        return !!(label && code)
    }

    return (
        <div className="panel surface-200 h-full p-4 mt-3 border-round flex flex-column w-6 col-offset-3">
            <h2>Create Commodity</h2>
            <label htmlFor="label" data-testid="Label">Label:</label>
            <InputText className="mb-3" name="label" invalid={!label} value={label} onChange={e => setLabel(e.target.value)} data-testid="LabelInput" />
            <label htmlFor="code" data-testid="Code">Code:</label>
            <InputText className="mb-3" name="code" invalid={!code} value={code} onChange={e => setCode(e.target.value)} data-testid="CodeInput" />
            <Button
                severity="success"
                icon="pi pi-save"
                label="Submit"
                onClick={() => setShowDialog(true)}
                data-testid='SubmitButton'
                disabled={!isformValid()}
            />
            <ConfirmDialog
                visible={showDialog}
                reject={() => setShowDialog(false)}
                onHide={() => setShowDialog(false)}
                accept={() => handleSubmitClick()}
                header="Are you sure you want to create a Commodity with the following data?"
                content={({ headerRef, contentRef, footerRef, hide, message }) => (
                    <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
                        <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                            <i className="pi pi-question text-5xl"></i>
                        </div>
                        <span className="font-bold text-2xl block mb-2 mt-4" ref={headerRef}>
                            {message.header}
                        </span>
                        <div>
                            <p><strong>Label: </strong>{label}</p>
                            <p><strong>Code: </strong>{code}</p>
                        </div>
                        <div className="flex align-items-center gap-2 mt-4">
                            <Button
                                severity="success"
                                label="Submit"
                                onClick={(event) => {
                                    hide(event);
                                    handleSubmitClick();
                                }}
                                className="w-8rem"
                                data-testid="DialogSubmitButton"
                            ></Button>
                            <Button
                                label="Cancel"
                                outlined
                                onClick={(event) => {
                                    hide(event);
                                    setShowDialog(false);
                                }}
                                className="w-8rem"
                                data-testid="DialogCancelButton"
                            ></Button>
                        </div>
                    </div>
                )}
                acceptLabel='Submit'
                rejectLabel='Cancel'
                data-testid="ConfirmDialog"
            />

            <Toast ref={toast} data-testid="toast" />

        </div>
    )
}